import { AsMainStepPipe } from './pipes/as-part-of-main-steps.pipe';
import { BypassSecurityPipe } from '@ebeihilfe/core';
import { CircleWithSegmentsComponent } from '@ebeihilfe/shared';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SingleStepComponent } from './single-step/single-step.component';
import { StepperComponent } from './stepper.component';
import { StepsSvgComponent } from '@ebeihilfe/web-shared/web-svgs/steps/steps.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [StepperComponent, SingleStepComponent],
  imports: [
    CircleWithSegmentsComponent,
    CommonModule,
    MatCardModule,
    MatIconModule,
    RouterModule,
    StepsSvgComponent,
    TranslateModule,
    BypassSecurityPipe,
    AsMainStepPipe,
  ],
  exports: [StepperComponent],
})
export class StepperModule {}
